import * as types from './actionTypes';

export const fetchPositions = (unit_id) => ({
  type: types.FETCH_POSITIONS_REQUEST,
  payload: { unit_id },
});

export const savePosition = (data) => ({
  type: types.SAVE_POSITION_REQUEST,
  payload: data,
});

export const changePositionStatus = (data) => ({
  type: types.CHANGE_POSITION_STATUS_REQUEST,
  payload: data,
});

export const fetchSkillMapping = (unit_id) => ({
  type: types.FETCH_SKILL_MAPPING_REQUEST,
  payload: { unit_id },
});

export const saveSkillMapping = (payload) => ({
  type: types.SAVE_SKILL_MAPPING_REQUEST,
  payload,
});

export const changeSkillMappingStatus = (payload) => ({
  type: types.CHANGE_SKILL_MAPPING_STATUS_REQUEST,
  payload,
});

export const fetchPositionsByDeptRole = (departmentId, roleId,unit_id) => ({
  type: types.FETCH_POSITIONS_BY_DEPT_ROLE_REQUEST,
  payload: { departmentId, roleId , unit_id},
});

export const fetchCompetencyList = (unit_id) => ({
  type: types.FETCH_COMPETENCY_LIST_REQUEST,
  payload: { unit_id },
});
